var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.4,
    height: 18.2,
    viewBox: "0 0 18.4 18.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_gruppi_di_lavoro",
    transform: "translate(-1222.8 -761.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_911",
    d: "M9.033,168.2a4.723,4.723,0,0,1,4,4.5v3.36H.741V172.7a4.722,4.722,0,0,1,4-4.5,5.51,5.51,0,0,0,4.293,0m-.11-.714a4.712,4.712,0,0,1-4.074,0A5.438,5.438,0,0,0,0,172.7v3.469a.6.6,0,0,0,.623.577H13.151a.6.6,0,0,0,.623-.577V172.7a5.438,5.438,0,0,0-4.85-5.216Z",
    transform: "translate(1223 602.922)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_912",
    d: "M194.978,167.484a4.7,4.7,0,0,1-.824.3,6.169,6.169,0,0,1,2.559,4.913v3.469a1.5,1.5,0,0,1-.118.577h2.61a.6.6,0,0,0,.623-.577V172.7A5.438,5.438,0,0,0,194.978,167.484Z",
    transform: "translate(1041.172 602.922)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_914",
    d: "M2107.4,305h1.438l.417,5.721-1.125.892-1.125-.892Z",
    transform: "translate(-878.375 466.953)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_60",
    transform: "translate(1225.588 762.042)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.219,
    cy: 4.219,
    r: 4.219,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.219,
    cy: 4.219,
    r: 3.719,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sottrazione_2",
    transform: "translate(1232.402 761.977) rotate(-3)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.687498450279236 7.9375 C 1.540403246879578 7.9375 1.394659757614136 7.929086685180664 1.250610709190369 7.912330627441406 C 2.358592987060547 7.030313014984131 3.030948400497437 5.678760528564453 3.030948400497437 4.219260215759277 C 3.030948400497437 2.759217023849487 2.358645915985107 1.40735125541687 1.250510811805725 0.5251812338829041 C 1.394589900970459 0.5084179043769836 1.540371656417847 0.5 1.687498450279236 0.5 C 3.738308429718018 0.5 5.406758308410645 2.168450117111206 5.406758308410645 4.219260215759277 C 5.406758308410645 6.269499778747559 3.738308429718018 7.9375 1.687498450279236 7.9375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.500162839889526 7.333652973175049 C 3.883144855499268 6.9727783203125 4.906758308410645 5.713278770446777 4.906758308410645 4.219260215759277 C 4.906758308410645 2.724653005599976 3.883080959320068 1.464706420898438 2.499946355819702 1.103823304176331 C 3.156116724014282 1.986599922180176 3.530948400497437 3.072720527648926 3.530948400497437 4.219260215759277 C 3.530948400497437 5.365369319915771 3.156204700469971 6.451107501983643 2.500162839889526 7.333652973175049 M 1.687498450279236 8.4375 C 1.100928425788879 8.4375 0.5331684350967407 8.319419860839844 -1.561050453346979e-06 8.086540222167969 C 1.537488460540771 7.414859771728516 2.530948400497437 5.897669792175293 2.530948400497437 4.219260215759277 C 2.530948400497437 2.54109001159668 1.537488460540771 1.022699952125549 -1.561050453346979e-06 0.3509700000286102 C 0.5347484350204468 0.1173899993300438 1.102498412132263 0 1.687498450279236 0 C 4.014008522033691 0 5.906758308410645 1.892750024795532 5.906758308410645 4.219260215759277 C 5.906758308410645 6.545209884643555 4.014008522033691 8.4375 1.687498450279236 8.4375 Z",
    stroke: "none",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupAction);
export default __webpack_public_path__ + "static/media/group_action.7a7f2f9363435189ec699f9846eeab31.svg";
export { ForwardRef as ReactComponent };